export default __webpack_public_path__ + "static/media/vitamin-b12.5d40f998.jpg";